import React from 'react';
import { Project } from '../../services/projectService';
import { formatProjectDate, getProjectCardTheme, getProjectStatusBadges } from './projectCardTheme';

const ActivityBadge: React.FC<{ label?: string }> = ({ label = 'New activity' }) => (
  <span className="activity-badge">
    <i />
    {label}
  </span>
);

interface Props {
  projects: Project[];
  onProjectClick: (projectId: string) => void;
}

const ProjectDashboardList: React.FC<Props> = ({ projects, onProjectClick }) => (
  <div className="dash-list">
    <div className="dash-list-header">
      <span>Project</span>
      <span>Description</span>
      <span>Start</span>
      <span>End</span>
      <span>Progress</span>
    </div>
    {projects.map((project, index) => {
      const theme = getProjectCardTheme(project);
      const badges = getProjectStatusBadges(theme, project);
      const pct = Math.min(100, Math.max(0, project.taskCompletion?.percent ?? 0));
      const completed = project.taskCompletion?.completed ?? 0;
      const total = project.taskCompletion?.total ?? 0;
      return (
        <button
          key={project._id}
          type="button"
          className={`dash-list-row is-${theme}${project.hasUnreadActivity ? ' has-activity' : ''}${index === projects.length - 1 ? ' is-last' : ''}`}
          onClick={() => onProjectClick(project._id)}
        >
          <div className="dash-list-project">
            <strong>{project.name}</strong>
            <div className="dash-list-badges">
              {project.hasUnreadActivity && <ActivityBadge />}
              {badges.map((badge) => (
                <span key={badge.label} className={`dash-status-badge is-${badge.tone}`}>
                  {badge.label}
                </span>
              ))}
            </div>
          </div>
          <p className="dash-list-desc">{project.description || 'No description'}</p>
          <span className="dash-list-date">{formatProjectDate(project.startDate)}</span>
          <span className={`dash-list-date${theme === 'critical' || theme === 'warning' ? ` is-${theme}` : ''}`}>
            {formatProjectDate(project.endDate)}
          </span>
          <div className="dash-list-progress">
            <div className="dash-list-progress-copy">
              <span>Completed {completed}/{total} tasks</span>
              <strong>{pct}%</strong>
            </div>
            <div className={`dash-progress-track is-${theme}`}>
              <span style={{ width: `${pct}%` }} />
            </div>
          </div>
        </button>
      );
    })}
  </div>
);

export default ProjectDashboardList;
